import {
  FALLBACK_ICON,
  ICON_ALIASES,
  ICON_MARKUP,
} from './icon-catalog.generated';

export function canonicalIconName(name: string): string {
  const canonical = ICON_ALIASES[name] ?? name;
  return ICON_MARKUP[canonical] ? canonical : FALLBACK_ICON;
}

/**
 * The shared Resonance icon renderer. Artwork comes from the repository-level
 * Tabler SVG catalog that also generates the iOS vector assets.
 */
export function Icon({
  name,
  size = 18,
  className,
}: {
  name: string;
  size?: number;
  className?: string;
}) {
  const canonical = canonicalIconName(name);
  const markup = ICON_MARKUP[canonical] ?? ICON_MARKUP[FALLBACK_ICON] ?? '';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      {...(className ? { className } : {})}
      // The markup is generated from the checked-in, licensed SVG catalog.
      dangerouslySetInnerHTML={{ __html: markup }}
    />
  );
}
